const getAtmPercentageRange = (limit = 10, sign = '+') => {
  const range = [];
  let count = 0;

  while (count < limit) {
    const newCount = count + 0.25;

    let value = parseFloat((newCount * 0.01).toFixed(4));

    value = sign === '-' ? -Math.abs(value) : value;

    range.push({
      label: `ATM${sign}${newCount}%`,
      value,
    });
    count = newCount;
  }

  return range;
};

export const createAtmPercentageLevels = ({ itm = 10, otm = 10 }) => {
  const itms = getAtmPercentageRange(itm, '-');
  const otms = getAtmPercentageRange(otm);

  return [...itms.reverse(), { label: 'ATM', value: 0 }, ...otms];
};
